interface ApiConfig {
  apiBaseUrl: string;
  authUrl: string;
  /** Da dove si leggono le immagini gia' caricate. */
  cdnBaseUrl: string;
}

export const apiConfig: ApiConfig = window.location.hostname === 'localhost' ? {
  apiBaseUrl: 'http://localhost:3000/api/',
  authUrl: 'http://localhost:3000/auth/',
  cdnBaseUrl: 'https://cdn.infooggi.it',
} : {
  apiBaseUrl: 'https://backend.infooggi.it/be/api/',
  authUrl: 'https://backend.infooggi.it/be/auth/',
  cdnBaseUrl: 'https://cdn.infooggi.it',
}